import React, { useState } from 'react';
import './../../entrydoor.css';
import { Url } from '../../url.js'; // Import the base URL

const LiteCollection = ({ value, onChange, label = 'Lite Collection' }) => {
    const [selectedLiteCollection, setSelectedLiteCollection] = useState(value || "");

    const handleLiteCollectionChange = async (e) => {
        const newValue = e.target.value;
        setSelectedLiteCollection(newValue); // Update local state
        //onChange([]); // Clear LiteCollectionData before fetching new data
        const element = document.getElementById('LiteCollectionData');
        const element1 = document.getElementById('TransomOption');
        if (newValue === 'CustomGlassCoutoutOptions'){
            if (element){
                element.style.display = "none";
                const label = element.previousElementSibling; // Fetch the label, if present
                if (label) {
                    label.style.display = "none";
                }
            }
            if (element1){
                element1.style.display = "block";
                const label1 = element1.previousElementSibling; // Fetch the label, if present
                if (label1) {
                    label1.style.display = "block";
                }
            }
            return;
        }
        else{
            if (element){
                element.style.display = "block";
                const label = element.previousElementSibling; // Fetch the label, if present
                if (label) {
                    label.style.display = "block";
                }
            }
            if (element1){
                element1.style.display = "none";
                const label1 = element1.previousElementSibling; // Fetch the label, if present
                if (label1) {
                    label1.style.display = "none";
                }
            }
        }

        try {
            // Fetch the entire litecollection object
            const response = await fetch(`${Url}/${newValue.toLowerCase()}`);
            if (!response.ok) {
                throw new Error(`Failed to fetch litecollection data`);
            }
            const data = await response.json();

            // Get the select element
            const selectElement = document.getElementById('LiteCollectionData');
        
            // Clear previous options
            selectElement.innerHTML = ''; // This removes all existing options

            // Add the default "Please select" option
            const defaultOption = document.createElement('option');
            defaultOption.value = ''; // Empty value for the default option
            defaultOption.textContent = 'Select an option';
            defaultOption.selected = true;
            selectElement.appendChild(defaultOption);

            // Check if data is an array and populate the select element
            if (Array.isArray(data) && data.length > 0) {
                data.forEach(item => {
                    const option = document.createElement('option');
                    option.value = item.value; //item.id; // Set the value attribute (e.g., "1")
                    option.textContent = item.value; // Set the visible text (e.g., "A")
                    selectElement.appendChild(option);
                    });
                selectElement.value = '';
                defaultOption.setAttribute('selected', 'Select an option');
            }
        } catch (error) {
            console.error("Error fetching LiteCollectionData:", error);
            onChange([]); // Clear LiteCollectionData in case of error
        }
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} htmlFor="LiteCollection">{label}</label>
            <select style={{ display: "none" }}
                id="LiteCollection"
                value={selectedLiteCollection}
                onChange={handleLiteCollectionChange}
            >
                <option value="" disabled hidden>
                    {selectedLiteCollection === "" ? "Select Lite Collection ✔" : "Select Lite Collection"}
                </option>
                <option value="decorativeglass">
                    {selectedLiteCollection === "decorativeglass" ? "Decorative Glass ✔" : "Decorative Glass"}
                </option>
                <option value="texturedglass">
                    {selectedLiteCollection === "texturedglass" ? "Textured Glass ✔" : "Textured Glass"}
                </option>
                <option value="wroughtiron">
                    {selectedLiteCollection === "wroughtiron" ? "Wrought Iron ✔" : "Wrought Iron"}
                </option>
                <option value="commodityglass">
                    {selectedLiteCollection === "commodityglass" ? "Commodity Glass ✔" : "Commodity Glass"}
                </option>
                <option value="CustomGlassCoutoutOptions">
                    {selectedLiteCollection === "CustomGlassCoutoutOptions" ? 
                    "Custom Glass/Coutout Options ✔" : "Custom Glass/Coutout Options"}
                </option>
            </select>
        </div>
    );
};

export default LiteCollection;
